import * as ActionCreators from './actionCreators';
import { appConstants } from '../constants/appConstants';
import { methodConstants } from '../constants/methodConstants';
import * as ErrorActions from './errorActions';
import * as Http from '../api/http';
import * as CommonActions from './commonActions';
import { orderSearchData } from '../../fakeData/orderSearchData';
import { onOrderSearch } from './orderSearchActions';
import * as DefaultActions from './defaultActions';
import { initialManuallyEnteredValues } from '../initializeObjects/bankAccountFilters';
import { validateManuallyEnteredDate } from '../actions/bankAccountActions';

let ordersFilterObj = {};
const initializePage = 1;

export const setSelectedDate = (date, property) => (dispatch, getState) => {
  ordersFilterObj = getState().ordersFilters;
  ordersFilterObj[property] = date;
  dispatch(ActionCreators.ordersFilters(ordersFilterObj));
};
export const setFromDate = (date, isValidate) => (dispatch) => {
  if(isValidate)
    dispatch(validateManuallyEnteredDate(date, 'fromDate'));
  dispatch(setSelectedDate(date, 'fromDate'));
};
  
export const setToDate = (date, isValidate) => (dispatch) => {
  if(isValidate)
    dispatch(validateManuallyEnteredDate(date, 'toDate'));
  dispatch(setSelectedDate(date, 'toDate'));
};

function getOrdersData(state, pageNumber) {
  const ordersFilters = state.ordersFilters;
  if(CommonActions.checkDateFilter(ordersFilters)){
    ordersFilters.fromDate = '';
    ordersFilters.toDate = '';
  }
  const params = {
    'startDate': CommonActions.getDateInSpecificFormat(ordersFilters.fromDate),
    'endDate': CommonActions.getDateInSpecificFormat(ordersFilters.toDate),
    'page.start': pageNumber-1,
    'page.size': state.ordersViewsPerPage,
    'sort.column': 'activityDate',
    'sort.order': ordersFilters.sortBy ? ordersFilters.sortBy : 'desc',
    'nocache': Date.now().toString()
  };
  const ordersAPI = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_OVERVIEW_INFO, state);
  return new Promise(((resolve, reject) => {
    Http.get(ordersAPI, state, params).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  }));
}

function getLayoutsData(state) {
  const layoutUrl = CommonActions.getFullApiUrl(methodConstants.GET_LAYOUT_URL, state);
  return new Promise(((resolve, reject) => {
    Http.get(layoutUrl, state).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  }));
}

function getInitialConfiguration(state, pageNumber) {
  return Promise.all([getLayoutsData(state), getOrdersData(state, pageNumber)]);
}

export const setSortBy = (sort, page) => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
  const currentState = getState();
  const {
    pathname
  } = currentState.routing.locationBeforeTransitions;
  if(CommonActions.isDefined(currentState.sideNavContent) && CommonActions.isDefined(currentState.sideNavContent.submenu)){
    dispatch(DefaultActions.handleNavSelect('', pathname));
  }
  const trans = currentState.translations;
  ordersFilterObj = currentState.ordersFilters;
  if((ordersFilterObj.fromDate === '' || ordersFilterObj.toDate === '' )|| (CommonActions.isDefined(ordersFilterObj.fromDate) && CommonActions.isDefined(ordersFilterObj.toDate))){
    const errorMsg = CommonActions.validateDates(ordersFilterObj.fromDate, ordersFilterObj.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      dispatch(ErrorActions.displayError(obj));
    } else{
      ordersFilterObj.sortBy = sort;
      dispatch(ActionCreators.ordersFilters(ordersFilterObj));
      const pagination = currentState.ordersPagination;
      let pageVal = pagination.pageSelected;
      if(page)
        pageVal = page;
      dispatch(ActionCreators.isLoading(true));
      getInitialConfiguration(currentState, pageVal)
        .then(([layoutData, ordersData]) => {
          let dateFormat = '';
          if(CommonActions.isDefined(layoutData.customer.config.dateFormat)){
            dateFormat = layoutData.customer.config.dateFormat;
          }
          dispatch(ActionCreators.customerDateFormat(dateFormat));
          dispatch(dispatchOrderActions(ordersData, pageVal));
          dispatch(ActionCreators.selectedDropDownValue('isDownload'));
          dispatch(ActionCreators.isLoading(false));
          dispatch(ActionCreators.displayLoader(false));
          const pathName = appConstants.ROUTE_ORDERS;
          const url = CommonActions.getFullApiUrl(pathName, currentState);
          dispatch(CommonActions.route(url));
        })
        .catch((err) => {
          dispatch(ErrorActions.displayError(err));
        });
    }
  }
  
};

export const applyOrdersFilters = () => (dispatch, getState) => {
  const currentState = getState();
  const trans = currentState.translations;
  const ordersFilters = currentState.ordersFilters;
  if(CommonActions.isDefined(ordersFilters.fromDate) && CommonActions.isDefined(ordersFilters.toDate)){
    const errorMsg = CommonActions.validateDates(ordersFilters.fromDate, ordersFilters.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      dispatch(ErrorActions.displayError(obj));
    } else{
      dispatch(getOrders(initializePage));
    }
  }else if(CommonActions.checkDateFilter(ordersFilters)){
    const obj = {
      statusText: trans['date-status-text']
    };
    dispatch(ErrorActions.displayError(obj));
  }
};

export const updatePagination = (summary, pageNumber) => (dispatch, getState) => {
  const customPagination = getState().ordersPagination;
  const ordersViewsPerPage = getState().ordersViewsPerPage;
  CommonActions.preparePagination(customPagination,summary.total, ordersViewsPerPage, pageNumber);
  dispatch(ActionCreators.ordersPagination(customPagination));
};

export const dispatchOrderActions = (orders, pageNumber) => (dispatch, getState) => {
  const customerDateFormat = getState().customerDateFormat;
  const ordersList = orders.collection;
  ordersList.forEach(function(order){
    order.activityDate = CommonActions.getDateGenericFormatTimeZone(order.activityDate, customerDateFormat);
  });
  dispatch(ActionCreators.ordersList(ordersList));
  if (ordersList.length !== 0) {
    dispatch(updatePagination(orders, pageNumber));
  }
};

export const getOrders = (pageNumber) => (dispatch, getState) => {
  const currentState = getState();
  const ordersFilters = currentState.ordersFilters;
  dispatch(ActionCreators.displayLoader(true));
  const ordersAPI = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_OVERVIEW_INFO, currentState);
  if(CommonActions.checkDateFilter(ordersFilters)){
    ordersFilters.fromDate = '';
    ordersFilters.toDate = '';
  }
  const params = {
    'startDate': CommonActions.getDateInSpecificFormat(ordersFilters.fromDate),
    'endDate': CommonActions.getDateInSpecificFormat(ordersFilters.toDate),
    'page.start': pageNumber-1,
    'page.size': currentState.ordersViewsPerPage,
    'sort.column': 'activityDate',
    'sort.order': ordersFilters.sortBy ? ordersFilters.sortBy : 'desc',
    'nocache': Date.now().toString()
  };
  Http.get(ordersAPI, currentState, params).then((res) => {
    CommonActions.scrollToTop();
    dispatch(dispatchOrderActions(res, pageNumber));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
      dispatch(ActionCreators.displayLoader(false));
    });
};

export const onPrintOrderDetails = (id, pageNumber, type, link) => (dispatch, getState) => {
  let errorFlag = false;
  if(type !== undefined){
    type = type.toLowerCase();
  }
  const currentState = getState();
  const trans = currentState.translations;
  const ordersFilters = currentState.ordersFilters;
  dispatch(ActionCreators.displayLoader(true));
  const ordersAPI = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_OVERVIEW_INFO, currentState);
  if(CommonActions.isDefined(ordersFilters.fromDate) && CommonActions.isDefined(ordersFilters.toDate)){
    const errorMsg = CommonActions.validateDates(ordersFilters.fromDate, ordersFilters.toDate);
    if(errorMsg){
      const obj = {
        statusText: trans['error.start-end-msg']
      };
      errorFlag = true;
      dispatch(ErrorActions.displayError(obj));
    }
  }
  if(CommonActions.checkDateFilter(ordersFilters)){
    ordersFilters.fromDate = '';
    ordersFilters.toDate = '';
    dispatch(ActionCreators.ordersFilters(ordersFilters));
  }
  if(!errorFlag){
    const params = {
      'startDate': CommonActions.getDateInSpecificFormat(ordersFilters.fromDate),
      'endDate': CommonActions.getDateInSpecificFormat(ordersFilters.toDate),
      'page.start': pageNumber-1,
      'page.size': currentState.ordersViewsPerPage,
      'sort.column': 'activityDate',
      'sort.order': ordersFilters.sortBy ? ordersFilters.sortBy : 'desc',
      'download': type,
      'nocache': Date.now().toString()
    };
    Http.get(ordersAPI, currentState, params).then((res) => {
      if(link === appConstants.PRINT)
        CommonActions.getFileOpenFromByteArray(res, CommonActions.getExtension(type));
      else{
        const customerDateFormat = getState().customerDateFormat;
        const personalInfoValues = getState().personalInfoValues;
        const fileName = `${personalInfoValues ? `${personalInfoValues.fullName}_${appConstants.ORDERS}`: 'OrdersReport'}_${CommonActions.getDateInSpecificFormat(new Date(), customerDateFormat ? customerDateFormat.toUpperCase(): 'DD-MM-YYYY')}`;
        CommonActions.downloadFileFromByteArray(res, fileName, CommonActions.getExtension(type));
      }
      dispatch(ActionCreators.displayLoader(false));
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
      });
  }
};

export const navigateToAwardDetails = (sapOrderId) => (dispatch, getState) => {
  const currentState = getState();
  const url = appConstants.ROUTE_AWARD_DETAILS + '/'+sapOrderId;
  const fullUrl = currentState.basePath + url;
  dispatch(CommonActions.route(fullUrl));
};

export const getAwards = (orderId, sapOrderId) => (dispatch, getState) => {
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  let ordersAwardsAPI = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_AWARDS, currentState);
  ordersAwardsAPI = CommonActions.modifyString(ordersAwardsAPI, '{:orderId}', sapOrderId);
  const data={};
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(ordersAwardsAPI, currentState, request).then((res) => {
    data.name = currentState.personalInfoValues.fullName;
    data.sapOrderId = sapOrderId;
    data.orderId = orderId;
    data.collection = res.collection;
    data.description = res.shortDescription ? res.shortDescription : res.fullDescription;
    dispatch(ActionCreators.awardDetailValues(data));
    CommonActions.scrollToTop();
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
    });
};

export const fetchOrderDetailsByOrderId = (orderId) => (dispatch, getState) => {
  const currentState = getState();
  const { orderDetailValues, routing } = currentState;
  const { pathname } = routing.locationBeforeTransitions;
  if (orderDetailValues.orderId === orderId && pathname.indexOf(`/orderdetails/${orderId}`) > 0) {
    dispatch(ActionCreators.displayLoader(false));
    return false;
  }

  if(CommonActions.isDefined(currentState.sideNavContent) && CommonActions.isDefined(currentState.sideNavContent.submenu)){
    dispatch(DefaultActions.handleNavSelect('', pathname));
  }
  const trans = currentState.translations;
  if (orderId === undefined) {
    dispatch(ActionCreators.infoMessage(CommonActions.errorMessage('Incorrect Order Number.')));
    dispatch(ActionCreators.displayMessage(true));
    return false;
  }else if (orderId.length === 0) {
    dispatch(ActionCreators.infoMessage(CommonActions.errorMessage(trans['enter-order-number'])));
    dispatch(ActionCreators.displayMessage(true));
    return false;
  }
  const data={};
  dispatch(ActionCreators.displayLoader(true));
  let ordersAwardsAPI = CommonActions.getFullApiUrl(methodConstants.GET_ORDERS_DETAILS, currentState);
  ordersAwardsAPI = CommonActions.modifyString(ordersAwardsAPI, '{:orderId}', orderId);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(ordersAwardsAPI, currentState, request).then((res) => {
    data.name = res.recipientName;
    data.sapOrderId = res.sapOrderId;
    data.orderDate=res.orderDate;
    data.orderId = orderId;
    if(res.accessCode){
      data.description = res.accessCode;
      data.accessCode = true;
    }else{
      data.description = res.totalPoints;
      data.accessCode = false;
    }
    data.collection = res.lineItems;
    data.programName = res.programName;
    data.awardLevel = res.awardLevel;
    data.showReturnAwardLink = res.showReturnAwardLink;
    data.accessCodeFlag = res.accessCodeFlag;
    data.emailAddress = res.emailAddress;
    data.telephoneNumber = res.telephoneNumber;
    dispatch(ActionCreators.orderDetailValues(data));

    CommonActions.scrollToTop();
    const url = `${appConstants.ROUTE_ORDER_DETAILS}/${orderId}`;
    const fullUrl = `${currentState.basePath}${url}`;
    dispatch(CommonActions.route(fullUrl));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
      dispatch(ActionCreators.displayLoader(false));
    });
};

export const getOrderDetails = (orderId) => (dispatch) => {
  dispatch(fetchOrderDetailsByOrderId(orderId));
};


export const getOrderSearch = () => (dispatch, getState) => {
  const currentState = getState();
  dispatch(CommonActions.route(CommonActions.getFullApiUrl(appConstants.ROUTE_ORDER_SEARCH, currentState)));
};


export const onPagination = (page, pageAction) => (dispatch, getState) => {
  const currentState = getState();
  const pagination = currentState.ordersPagination;
  let specificPage = 0;
  let selectedPage = 1;
  if (pageAction) {
    if (typeof page === appConstants.TYPE_OF_OBJECT) {
      specificPage = page.item;
    } else if (typeof page === appConstants.TYPE_OF_STRING) {
      if (page === appConstants.PREVIOUS) {
        specificPage = pagination.pageSelected - 1;
      } else {
        specificPage = pagination.pageSelected + 1;
      }
    }
    if (specificPage !== pagination.pageSelected) {
      dispatch(ActionCreators.displayLoader(true));
      selectedPage = specificPage;
      dispatch(getOrders(selectedPage));
    }
  }
};

export const setOrdersViewsPerPage = (ordersViewsPerPage) => (dispatch, getState) => {
  const currentState = getState();
  if(currentState.ordersViewsPerPage !== ordersViewsPerPage)
    dispatch(ActionCreators.ordersViewsPerPage(ordersViewsPerPage));
  dispatch(getOrders(initializePage));
};


export const setActiveTab = (index) => (dispatch) => {
  dispatch(ActionCreators.tabSelected(index));
};

export const openProgramsDropdown = (isOpen) => (dispatch) => {
  dispatch(ActionCreators.programsDropdownOpen(!isOpen));
};

export const ordersSearchJson = () => (dispatch, getState) => {
  const searchColumns = [appConstants.ORDER_SEARCH.ORDER_NUMBER,
    appConstants.ORDER_SEARCH.RECEIPIENT_NAME, 
    appConstants.ORDER_SEARCH.PROGRAM, 
    appConstants.ORDER_SEARCH.AWARD_LEVEL, 
    appConstants.ORDER_SEARCH.DESCRIPTION,
    appConstants.ORDER_SEARCH.STATUS];
  const searchRows = [];
  const currentState = getState();
  dispatch(ActionCreators.displayLoader(true));
  const searchUrl = CommonActions.getFullApiUrl(methodConstants.GET_SEARCH, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(searchUrl, currentState, request).then((res) => {
    res.collection.forEach ((item) => {
      const row = {};
      row[appConstants.ORDER_SEARCH.ORDER_NUMBER] = item['orderNumber'];
      row[appConstants.ORDER_SEARCH.RECEIPIENT_NAME] = item['receipientName'];
      row[appConstants.ORDER_SEARCH.PROGRAM] = item['program'] ;
      row[appConstants.ORDER_SEARCH.AWARD_LEVEL] = item['awardLevel'];
      row[appConstants.ORDER_SEARCH.DESCRIPTION]= item['description'];
      row[appConstants.ORDER_SEARCH.STATUS]= item['status'];
      searchRows.push(row);
    });
    const tableDataReceived = {columns: searchColumns, rows: searchRows};
    dispatch(ActionCreators.ordersSearchData(tableDataReceived));
    dispatch(ActionCreators.displayLoader(false));
    dispatch(ActionCreators.ordersSearchDisplay(true));
  })
    .catch(() => {
      const res = orderSearchData;
      res.collection.forEach ((item) => {
        const row = {};
        row[appConstants.ORDER_SEARCH.ORDER_NUMBER] = item['orderNumber'];
        row[appConstants.ORDER_SEARCH.RECEIPIENT_NAME] = item['receipientName'];
        row[appConstants.ORDER_SEARCH.PROGRAM] = item['program'] ;
        row[appConstants.ORDER_SEARCH.AWARD_LEVEL] = item['awardLevel'];
        row[appConstants.ORDER_SEARCH.DESCRIPTION]= item['description'];
        row[appConstants.ORDER_SEARCH.STATUS]= item['status'];
        searchRows.push(row);
      });
      const tableDataReceived = {columns: searchColumns, rows: searchRows};
      dispatch(ActionCreators.ordersSearchData(tableDataReceived));
      dispatch(ActionCreators.displayLoader(false));
      dispatch(ActionCreators.ordersSearchDisplay(true));
    });
};

export const getPermissionsDisplayItems = () => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const currentState = getState();
  const displayItemsUrl = CommonActions.getFullApiUrl(methodConstants.GET_PERMISSIONS_ORDER_SEARCH, currentState);
  const request = {
    'nocache': Date.now().toString()
  };
  Http.get(displayItemsUrl, currentState, request).then((res) => {
    dispatch(ActionCreators.permissionDisplayItems(res));
    dispatch(ActionCreators.displayLoader(false));
  })
    .catch((err) => {
      dispatch(ErrorActions.displayError(err));
      dispatch(ActionCreators.displayLoader(false));
    });
};

export const getOrderSearchPrograms = () => (dispatch, getState) => {
  dispatch(ActionCreators.displayLoader(true));
  const currentState = getState();
  const trans = currentState.translations;
  if (Object.keys(trans).length > 0) {
    const programsUrl = CommonActions.getFullApiUrl(methodConstants.GET_ORDER_SEARCH_PROGRAMS, currentState);
    const request = {
      'nocache': Date.now().toString()
    };
    Http.get(programsUrl, currentState, request).then((res) => {
      const obj = {
        programId: -1,
        programName: '',
        programNameString: trans['all-programs']
      };
      const resArr = res.collection;
      resArr.unshift(obj);
      const data = CommonActions.formatDropdown(resArr, appConstants.ORDER_SEARC_PROGRAM_KEYS);
      dispatch(ActionCreators.orderSearchPrograms(data));
      dispatch(ActionCreators.displayLoader(false));
      dispatch(onOrderSearch(obj.programNameString, 'programNameString'));
      dispatch(onOrderSearch(obj.programId, 'programId'));
    })
      .catch((err) => {
        dispatch(ErrorActions.displayError(err));
        dispatch(ActionCreators.displayLoader(false));
      });
  }
};

export const initializeOrdersPage = () => (dispatch, getState) => {
  dispatch(ActionCreators.ordersSearchDisplay(false));
  dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
  dispatch(getOrderSearchPrograms());
  dispatch(getPermissionsDisplayItems());
  const resOrderSearch = getState().orderSearch;
  Object.keys(resOrderSearch).forEach(prop => {
    resOrderSearch[prop] = '';
  });
  dispatch(ActionCreators.orderSearch(resOrderSearch));
};

export const clearFilters = (isInitialViews) => (dispatch, getState) => {
  const currentState = getState();
  const ordersFilters = currentState.ordersFilters;
  ordersFilters.sortBy = '';
  ordersFilters.fromDate = '';
  ordersFilters.toDate = '';
  if(document.getElementById('from-date') && document.getElementById('to-date')){
    document.getElementById('from-date').value = '';
    document.getElementById('to-date').value = '';
  }
  if(isInitialViews){
    const ordersViewsPerPage = 10;
    dispatch(ActionCreators.ordersViewsPerPage(ordersViewsPerPage));
  }
  dispatch(ActionCreators.ordersFilters(ordersFilters));
};

export const clearSearchResults = () => (dispatch) => {
  dispatch(clearFilters());
  dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
  dispatch(getOrders(1));
};

export const setDateCalendar = (property, display) => (dispatch) => {
  const isDisplay = display ===  false ? false : true;
  if(property === 'from'){
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
  }else if(property === 'to'){
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }else{
    dispatch(ActionCreators.isDisplayFromDateCalendar(isDisplay));
    dispatch(ActionCreators.isDisplayToDateCalendar(isDisplay));
  }
};

export const onDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(setFromDate(date));
    dispatch(setDateCalendar('from', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      if (ele) {
        ele.focus();
      }
    }
  }
  
};

export const onEndDaySelected = (date, modifiers, charCode) => (dispatch) => {
  if (!modifiers.disabled) {
    dispatch(ActionCreators.manuallyEnteredDate(initialManuallyEnteredValues));
    dispatch(setToDate(date));
    dispatch(setDateCalendar('to', false));
    if (charCode === appConstants.DAY_PICKER_ENTER_ACTION ) { // 0 for react day picker enter
      //const ele = document.querySelector('.display-end-toggle .toggle-switch .react-switch-handle');
      const ele = document.querySelector('.button');
      if (ele) {
        ele.focus();
      }
    }
  }
};
